export class DetalleDominio {
    public detalleDominioPK: DetalleDominioPK;
    public estado: number;
    public valor: string;
    public icono: string;

    constructor(detalleDominioPK: DetalleDominioPK) {
        this.detalleDominioPK = detalleDominioPK;
    }
}

export class DetalleDominioPK {
    public nombreDetalleDominio: string;
    public nombreDominio: string;

    constructor(nombreDetalleDominio: string, nombreDominio: string) {
        this.nombreDetalleDominio = nombreDetalleDominio;
        this.nombreDominio = nombreDominio;
    }
}